// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___QjIsm","open":"open___2_KYV","editor":"editor___3y5dD"};